export interface LocationSalaryStatsAggregate {
  percentile25?: { min?: number; max?: number };
  median?: { min?: number; max?: number };
  percentile75?: { min?: number; max?: number };
  sampleSize?: number;
}

export interface LocationSalaryPercentileSeoData {
  percentile25: number;
  percentile50: number;
  percentile75: number;
  sampleSize: number | null;
}

function pickPositiveNumber(...values: Array<number | undefined>): number | null {
  for (const value of values) {
    if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
      return value;
    }
  }
  return null;
}

export function buildLocationSalaryPercentileSeoData(
  aggregate: LocationSalaryStatsAggregate | null | undefined,
): LocationSalaryPercentileSeoData | null {
  if (!aggregate) return null;

  const percentile25 = pickPositiveNumber(aggregate.percentile25?.min, aggregate.percentile25?.max);
  const percentile50 = pickPositiveNumber(aggregate.median?.min, aggregate.median?.max);
  const percentile75 = pickPositiveNumber(aggregate.percentile75?.min, aggregate.percentile75?.max);

  if (percentile25 === null || percentile50 === null || percentile75 === null) {
    return null;
  }

  const sampleSize =
    typeof aggregate.sampleSize === 'number' &&
    Number.isFinite(aggregate.sampleSize) &&
    aggregate.sampleSize > 0
      ? Math.round(aggregate.sampleSize)
      : null;

  return {
    percentile25,
    percentile50,
    percentile75,
    sampleSize,
  };
}
